import { useSearchParams } from 'react-router-dom'

export const useApplicationGroupId = (): string | null => {
  const [searchParams] = useSearchParams()
  const applicationGroupId = searchParams.get('applicationGroupId')

  return applicationGroupId
}
